// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutSlider_wrapper__0DWJf","preview":"CheckoutSlider_preview__sce40"};